import { type ReactNode } from 'react';
import { FixedBottomFooter } from './FixedBottomFooter';
export interface MobileCTAFooterProps {
  children: ReactNode;
  /** 푸터 바로 위에 띄우는 문구(예: 잠긴 플랜 안내). */
  floatingText?: ReactNode;
}

/**
 * 모바일 전용 하단 고정 CTA. `tablet-sm` 이상에서는 숨고, 데스크톱 사이드 CTA 가 대신한다.
 * 퀴즈 상세와 폴더 상세가 함께 쓴다.
 */
export const MobileCTAFooter = ({
  children,
  floatingText
}: MobileCTAFooterProps) => {
  return <FixedBottomFooter className="border-t border-alternative bg-white px-md py-xs shadow-lg tablet-sm:hidden" data-sentry-element="FixedBottomFooter" data-sentry-component="MobileCTAFooter" data-sentry-source-file="MobileCTAFooter.tsx">
      {/* 푸터 위로 띄운다 — 푸터 높이에 묶이지 않게 translate 로 올린다. */}
      {Boolean(floatingText) && <div className="absolute left-1/2 -translate-x-1/2 -translate-y-[calc(100%+12px)]" data-component="floating-text-wrapper">
          {floatingText}
        </div>}
      {children}
    </FixedBottomFooter>;
};